import styled from 'styled-components';
import { ClearFix } from '../../ui-components/utils.styles';
import { device } from '../../ui-components/breakpoints';
import { Heading1 } from '../../ui-components/typography/Heading.styles';
import { regularWhite, fontWeightRegular, fontWeightBold } from '../../ui-components/design-tokens';
import { playFontSize } from '../../ui-components/typography/helpers';
import Recommendations from '../Recommendations/Recommendations';
import Showcase from 'app/ui-components/Showcase/Showcase';

export const Container = styled.section`
    max-width: 26em;
    margin: 30px auto 50px;
    ${ClearFix}
    
    @media ${device.GteSmall} {
        max-width: 44em;
        margin-bottom: 90px;
    }

    @media ${device.GteMedium} {
        max-width: 30em;
        margin-top: 60px;
    }

    @media ${device.GteLarge} {
        max-width: 570px;
        margin-bottom: 120px;
    }
`;

export const Heading = styled(Heading1)`
    text-align: center;
`;

export const Content = styled.div`
    margin-top: 50px;
    color: ${regularWhite};
`;

export const ListHeading = styled.p`
    ${playFontSize(1.7)};
    line-height: 1.4;
    margin-top: 1.8em;
    font-weight: ${fontWeightRegular};

    @media ${device.GteMedium} {
        font-weight: ${fontWeightBold};
    }

    @media ${device.GteLarge} {
        font-weight: ${fontWeightBold};
    }
`;

export const List = styled.ul`
    padding: 0 0 0 1.15em;
    line-height: 1.4;
    margin-bottom: 1.4em;
    margin-top: 0.2em;
    font-size: 1.6rem;

    @media ${device.GteSmall} {
        font-size: 1.7rem;
    }
`;

export const RecommendationsCarousel = styled(Recommendations)`
    display: none;
    margin-left: 0;
    margin-right: 0;

    @media ${device.GteXLarge} {
        display: block;
    }
`;

export const RecommendedShowcase = styled(Showcase)`
    display: block;

    @media ${device.GteXLarge} {
        display: none;
    }
`;
